import { ls, t } from '../i18n';
import { useId, useState } from 'react';
import { COLOR_FILTERS, COLOR_FILTER_LABELS, svgColorMatrix, type ColorFilter } from '@reels/shared/color';
import previewPhoto from '../assets/preview.webp';
import { Chips } from './Controls';
import { RangeControl } from './RangeControl';

export function ColorControls({ preset, intensity, onChange, showPreview = false }: {
  preset: ColorFilter; intensity: number;
  showPreview?: boolean;
  onChange: (patch: { colorFilter?: ColorFilter; colorIntensity?: number }) => void;
}) {
  // Change the filter resource URL too: some WebViews retain the first painted
  // SVG filter when only feColorMatrix values are updated.
  const filterId = `color-preview-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}-${preset}-${intensity}`;
  const [original, setOriginal] = useState(false);
  return <div className="col color-controls">
    {showPreview ? <div className="color-preview" role="region" aria-label={t('editor.colorPreview.aria')}>
      <svg key={filterId} className="color-filter-defs" aria-hidden="true" width="0" height="0">
        <defs><filter id={filterId} colorInterpolationFilters="sRGB">
          <feColorMatrix type="matrix" values={svgColorMatrix(preset, intensity)} />
        </filter></defs>
      </svg>
      <img src={previewPhoto} alt={t('editor.colorPreview.alt')}
        style={preset !== 'off' && !original ? { filter: `url(#${filterId})` } : undefined} />
      <span className="color-preview-label">{t('editor.colorPreview.label', { name: original ? t('editor.colorPreview.original') : ls(COLOR_FILTER_LABELS[preset]) })}</span>
      {preset !== 'off' ? <button type="button" className="color-preview-compare" aria-pressed={original}
        onClick={() => setOriginal(value => !value)}>
        {original ? t('editor.color.showFilter') : t('editor.color.compare')}
      </button> : null}
    </div> : null}
    <Chips ariaLabel={t('editor.color.filter')} value={preset}
      options={COLOR_FILTERS.map(value => ({ value, label: ls(COLOR_FILTER_LABELS[value]) }))}
      onChange={colorFilter => { setOriginal(false); onChange({ colorFilter }); }} />
    {preset !== 'off' ? <label className="col">
      <span className="row between"><span>{t('editor.color.intensity')}</span><span>{intensity}%</span></span>
      <RangeControl min={0} max={100} step={1} value={intensity} valueText={`${intensity}%`}
        label={t('editor.color.intensityAria')} onChange={colorIntensity => { setOriginal(false); onChange({ colorIntensity }); }} />
    </label> : null}
  </div>;
}
